export enum LmsFormActions {
    SUBMIT_LMS_FORM = 'submitLmsForm',
    HANDLE_LMS_RESPONSE = 'handleLmsResponse',
    CHANGE_LMS_INPUT = 'changeLmsInput',
    SET_LMS_OPENER = 'setLmsOpener',
    CLEAR_LMS_RESULT = 'clearLmsResult',
}

export enum LmsErrorNoti {
    GENERAL,
    MISSING_INPUT,
}
